import React from 'react';
import { useTranslation } from 'react-i18next';
import CasualtiesComponent from '../archive/CasualtiesComponent';

const CriminalComponent = ({ report, beta }) => {
  const { t } = useTranslation();

  if (!report.criminal_type) {
    return null;
  }

  return (
    <div className="further-details">
      {beta && <div className="border-b my-4 border-[#F4F5F7]" />}
      <h2>Further Details</h2>
      <table>
        <tbody>
          <tr>
            <th>Crime Type</th>
            <td>{t(`criminal.${report.criminal_type.toLowerCase()}`)}</td>
          </tr>
          <CasualtiesComponent casualties={report.casualties} />
        </tbody>
      </table>
    </div>
  );
};

export default CriminalComponent;
